import React from 'react';
import styled from 'styled-components';
import CellContainer from '../CellContainer';

const CellStarDiv = styled.div`
  font-size: 14px;
  color: ${(props) => (props.filled ? '#f5a623' : 'rgba(173,181,189,0.2)')};
  :not(:last-child) {
    margin-right: 6px;
  }
`;

const CellStars = ({ stars = 0, hideEmpty, nbStars = 3, ...otherProps }) => (
  <CellContainer {...otherProps}>
    {[...Array(isNaN(stars) ? 0 : Number(stars))].map((star, index) => (
      <CellStarDiv key={`starsFilled-${index}`} filled>
        ★
      </CellStarDiv>
    ))}
    {!hideEmpty &&
      [...Array(nbStars - (isNaN(stars) ? 0 : Number(stars)))].map(
        (star, index) => (
          <CellStarDiv key={`starsEmpty-${index}`}>★</CellStarDiv>
        )
      )}
  </CellContainer>
);

export default CellStars;
